import React from 'react';
import moment from 'moment';
import { formatPhoneNumber } from 'utils';
import { PendingRegisteredOffer } from '@bb/domain/dist/types';

export interface Offer {
  coop: {
    name: string;
    email: string;
    phone: string;
    org: { name: string; phone: string };
  };
  createdAt: string;
}

interface Form801InfoPaneProps {
  offer: Offer | PendingRegisteredOffer;
}

const Form801InfoPane = (props: Form801InfoPaneProps) => {
  const {
    offer: { coop, createdAt },
  } = props;
  return (
    <div className="form-801-info-pane hidden-xs">
      <p>Submitted Online by Showing Agent:</p>
      <p>
        {coop.name}
        <br />
        {coop.org.name}
        <br />P {formatPhoneNumber(coop.org.phone)}
        <br />M {formatPhoneNumber(coop.phone)}
        <br />
        {coop.email}
      </p>
      <p>{moment(createdAt).format('MMM D, YYYY, H:mm A')}</p>
    </div>
  );
};

export default Form801InfoPane;
